import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../../Forms/GenericFormContainer';

import { required } from '../../Forms/utils';

import { REACT_SELECT_INPUT, STYLED_TEXT } from '../../Forms/fieldTypes';

const form = 'BanMember';

const BanMemberComponent = ({
  onSubmit,
  onLoad,
  membersOptions,
  initialValues,
}) => {
  const { t } = useTransl();
  const formData = [
    {
      keyName: 'personId',
      label: t('title.member'),
      fieldType: REACT_SELECT_INPUT,
      options: membersOptions,
      validate: [required],
    },
    {
      keyName: 'comment',
      label: t('title.comment'),
      fieldType: STYLED_TEXT,
      validate: [],
    },
  ];

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      onLoad={onLoad}
      initialValues={initialValues}
      submitText={t('community.banPerson')}
      isFullWidthForm
      enableReinitialize
      backButton={false}
      color="secondary"
    />
  );
};

BanMemberComponent.propTypes = {
  onLoad: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  membersOptions: PropTypes.instanceOf(Array).isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
};

export default BanMemberComponent;
